import React, { Component } from 'react';
import {Image, Button, Modal, Icon } from 'semantic-ui-react';


class RechtsLinks extends Component {

  handleClick(data) {
    this.props.handleClickParent(data)
  }

  render() {
    const {styleClass} = this.props;
    return (
      <div style={{ cursor: this.props.canContinue && 'pointer' }} 
        className={`slide__gallery ${styleClass}`}
        onClick={this.handleClick.bind(this, styleClass)
      }>
        <Icon size="big" name={this.props.name} />    
      </div>
    )    
  }
}

class ModalGalleyLayout extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      imageIndex: 0,
    }
    this.nberOfImages= this.props.images.length
  }

  handleGalleryShow = (styleClass) => { 

    if (styleClass === 'rightClass') {
      if (this.state.imageIndex < this.nberOfImages -1) {
        this.setState((state) => ({ imageIndex: ++state.imageIndex }) )
        return ;
      }
      return;
    }

    if (this.state.imageIndex > 0) {
      this.setState((state) => ({ imageIndex: --state.imageIndex }) )
      return;
    }
    return;
  }

  showModal = () => { this.setState({open: true})}

  closeConfigShow = (closeOnEscape, closeOnDimmerClick) => () => {
    this.setState({ closeOnEscape, closeOnDimmerClick, open: true })
  }

  close = () => this.setState({ open: false, imageIndex: 0 })

  render() {
    
    const { open, closeOnEscape, closeOnDimmerClick, imageIndex } = this.state;
    const next = imageIndex !== (this.nberOfImages - 1) ? true : false;
    const previous = imageIndex !== 0 ? true : false;

    return (
      <React.Fragment>

        <Button primary size="huge" className={this.props.buttonClass} 
            onClick={this.showModal}>
            {this.props.buttonTitle}
        </Button>
      
        <Modal
          open={open || this.props.openModal}
          closeOnEscape={closeOnEscape}
          closeOnDimmerClick={closeOnDimmerClick}
          onClose={this.close}
        > 
          
          <RechtsLinks handleClickParent={this.handleGalleryShow}
            name="chevron left" 
            styleClass="leftClass"
            canContinue={previous}
          />
          <RechtsLinks handleClickParent={this.handleGalleryShow} 
            name="chevron right" 
            styleClass="rightClass"
            canContinue={next}
          />

          <Modal.Content className="modal__image">

            <Image className="modal__image__item"
              src={this.props.images[this.state.imageIndex]}
            />

          </Modal.Content>

        </Modal>
        
      </React.Fragment>
    )
  }
}

ModalGalleyLayout.defaultProps = {
  buttonClass: ''
}

export default ModalGalleyLayout;